export const updateCropHarvestDate = "/farmer/updateHarvestDate";
export const updateSequenceInFarmer = "/farmer/updateSequenceInFarmer";
export const fetchMapCoordinates = "/fetchMapCoordinates";
export const getFieldOfficerReport = "/report/project";
export const misscaleneous = "/project/mis";
export const getJobs = "/driver/get_jobs";
